import { computed, defineComponent } from "vue"; // modules

import AuthModule from "@/store/modules/auth"; // components

import { NavbarMainMenu, NavbarDetectInternet, NavbarTabs, NavbarReloadConfig, NavbarScanQrCode, Intercom } from "@/components/index";
import { useI18n } from "vue-i18n";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import CashFloatModule from "@/store/modules/cash-float";
import AppModule from "@/store/modules/app";
export default defineComponent({
  name: "Navbar",
  components: {
    NavbarDetectInternet: NavbarDetectInternet,
    Intercom: Intercom,
    NavbarMainMenu: NavbarMainMenu,
    NavbarTabs: NavbarTabs,
    NavbarReloadConfig: NavbarReloadConfig,
    NavbarScanQrCode: NavbarScanQrCode
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var isAuth = computed(function () {
      return AuthModule.getIsAuth;
    });
    var isClosingCashfloat = computed(function () {
      return CashFloatModule.isClosingCashfloat;
    });
    var isLoading = computed(function () {
      return AppModule.isBackgroundLoading;
    });
    return {
      isAuth: isAuth,
      hasSalesStarted: hasSalesStarted,
      isClosingCashfloat: isClosingCashfloat,
      isLoading: isLoading
    };
  }
});